module.exports = __webpack_public_path__ + "static/media/icon-4.4a3c67f5.png";